module.exports = __webpack_public_path__ + "static/media/portfolio-gif.8b8e7233.gif";